import React, { FC } from 'react'
import { makeStyles } from '@material-ui/styles'
import classNames from 'classnames'

import StylesModule from 'components/lv3/topOldImage.module.scss'

import TopOldImage01 from 'images/top/message1.jpg'
import TopOldImage02 from 'images/top/message2.jpg'

const useStyles = makeStyles(() => ({
  TopOldImage01BG: {
    backgroundImage: `url(${TopOldImage01})`,
  },
  TopOldImage02BG: {
    backgroundImage: `url(${TopOldImage02})`,
  },
}))

const TopOldImage: FC = () => {
  const classes = useStyles()
  return (
    <section
      className={classNames(StylesModule.topOldImage, 'mt-30', 'mt-tb-64')}
    >
      <div className={classNames(StylesModule.topOldImage__image)}>
        <div className={classNames(StylesModule.topOldImage__imageMargin)}>
          <div
            className={classNames(
              StylesModule.topOldImage__imageResponsive,
              classes.TopOldImage01BG,
            )}
            role="img"
            aria-hidden="true"
          ></div>
          <div
            className={classNames(
              StylesModule.topOldImage__imageResponsive,
              classes.TopOldImage02BG,
            )}
            role="img"
            aria-hidden="true"
          ></div>
        </div>
      </div>
    </section>
  )
}

export default TopOldImage
